import tableAdminUsers from './tableAdminUsers';


export default {
  title: 'Admin Users',
  noArea:true,
  attributeName: 'users',
  idAttribute: 'id',
  getURL: 'users',
  createURL: 'users',
  updateURL: 'users',
  removeURL: 'users',
  sessionParams: [],
  // formConfig: [
  //   formAdminOrganizations,
  // ],
  tableConfig: tableAdminUsers,
  autoUpdate: true,
};
